import { resetPassword, confirmResetPassword } from "aws-amplify/auth";
import AccountsAPI from "./AccountsAPI";

const normalizeEmail = (email) => email.trim().toLowerCase();
const confirmationRequiredErrors = new Set([
  "UserNotConfirmedException",
  "NotAuthorizedException",
  "InvalidParameterException",
]);

export const requestRecoveryCode = async (email) => {
  const username = normalizeEmail(email);
  try {
    await resetPassword({ username });
    return "reset";
  } catch (error) {
    if (!confirmationRequiredErrors.has(error.name)) throw error;
    // Cognito cannot send a reset code until the email is verified. Send a
    // fresh confirmation code instead; the original sign-up code isn't needed.
    await AccountsAPI.post(
      "/sign-up/resend-code",
      { email: username },
      { requiresAuth: false }
    );
    return "verify";
  }
};

export const verifyRecoveryEmail = async (email, confirmationCode) => {
  await AccountsAPI.post(
    "/sign-up/confirm",
    { email: normalizeEmail(email), confirmationCode: confirmationCode.trim() },
    { requiresAuth: false }
  );
};

export const finishPasswordRecovery = (email, confirmationCode, newPassword) =>
  confirmResetPassword({
    username: normalizeEmail(email),
    confirmationCode: confirmationCode.trim(),
    newPassword,
  });
